export function fetchFileFromUrl(url: string, fileName: string = 'fetchedFile'): Promise<File> {
  return fetch(url)
    .then((response: Response) => response.blob())
    .then((blob: Blob) => new File([blob], fileName));
}
